var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"env-bar"},[(_vm.currentEnv != null)?_c('strong',[_vm._v(_vm._s(_vm.currentEnv.name))]):_vm._e(),(_vm.showLink)?_c('RouterLink',{attrs:{"to":{ name: 'ChangeEnv' }}},[_vm._v(" 切换 ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }